import { Box, Drawer, IconButton, List, ListItem, ListItemButton, Stack, Typography, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import MenuIcon from '@mui/icons-material/Menu';
import CustomButton from "../../components/form/custom-button";

const navigationLocale = "navigation";

const navOptions = [
    {label: 'home', to: '/'},
    {label: 'about', to: '/about'},
    {label: 'platform', to: '/platform'},
    {label: 'blog', to: '/blog'}
];

const NavigationBody = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    const [drawerState, setDrawerState] = useState(false);

    const [activePage, setActivePage] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        const location = window.location.href;

        const lastIndexOfSlash = location.lastIndexOf("/");

        if(location.length - lastIndexOfSlash === 1){
            setActivePage(0);
        }
        else{
            let index = -1;

            for(let i = 1; i < navOptions.length; i++){
                if(location.includes(navOptions[i].to.substring(1))){
                    index = i;
                    break;
                }
            }

            console.log(index);

            if(index !== -1){
                setActivePage(index);
            }
            else{
                setActivePage(-1);
            }
        }
    }, []);

    const clickNavigate = useCallback((redirect) => {
        setActivePage(redirect);
    }, []);

    const contactMe = useCallback(() => {
        navigate('/contact');
    }, []);

    const toggleDrawer = useCallback((status) => {
        setDrawerState(status);
    }, []);

    const selectNavOptionInMobile = useCallback((redirect) => {
        toggleDrawer(false);
        clickNavigate(redirect);

        navigate(redirect);
    }, []);

    return (
        <>
            <Box>
                <Stack 
                    direction='row' 
                    justifyContent='space-between' 
                    alignItems='center'
                    py={2}
                    px={{xs: 3, md: 5}}
                    borderRadius={5}
                    className="bodySideMargin1"
                    sx={{
                        backgroundColor: theme.palette.background.default,
                        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <Link to='/'>
                        <Box
                            sx={{
                                width: {xs: 100, md: 150}
                            }}
                        >
                            <img 
                                src="/images/logo/Logo1.png"
                                alt="Logo" 
                                width='100%'
                                style={{
                                    cursor: 'pointer'
                                }}
                            />
                        </Box>
                    </Link>

                    {/* PC View */}
                    <Stack
                        direction='row' 
                        justifyContent='space-between' 
                        alignItems='center'
                        sx={{
                            display: {xs: 'none', md: 'flex'}
                        }}
                    >
                        <Stack
                            direction='row' 
                            justifyContent='space-between' 
                            alignItems='center'
                        >
                            {
                                navOptions.map((item, index) => {
                                    return <Link 
                                        key={index}
                                        onClick={() => clickNavigate(item.to)}
                                        to={item.to}
                                        style={{
                                            textDecoration: 'none',
                                            color: 'black'
                                        }}
                                    >
                                        <Typography 
                                            px={3}
                                            className="onMouseOver"
                                            fontWeight={activePage === index ? 700 : 500}
                                            color={activePage === index ? theme.palette.primary.main : theme.palette.secondary.main}
                                            sx={{
                                                cursor: 'pointer',
                                                '&: hover': {
                                                    transform: 'scale(0.9)'
                                                }
                                            }}
                                        >
                                            {t(`${navigationLocale}.${item.label}`)}
                                        </Typography>
                                    </Link>
                                })
                            }
                        </Stack>

                        <CustomButton 
                            label={t(`${navigationLocale}.contact`)}
                            onClick={contactMe}
                        />
                    </Stack>

                    {/* Mobile View */}
                    <IconButton
                        onClick={() => toggleDrawer(true)}
                        sx={{
                            display: {xs: 'flex', md: 'none'}
                        }}
                    >
                        <MenuIcon fontSize='large' />
                    </IconButton>

                    <Drawer 
                        anchor="right"
                        open={drawerState} 
                        onClose={() => toggleDrawer(false)}
                    >
                        <List>
                            {
                                navOptions.map((item, index) => {
                                    return <ListItem 
                                        disablePadding
                                        key={index}
                                        sx={{
                                            pt: index === 0 ? 2 : 0
                                        }}
                                    >
                                        <ListItemButton
                                            onClick={() => selectNavOptionInMobile(item.to)}
                                        >
                                            <Typography
                                                py={1}
                                                px={5}
                                                className="onMouseOver"
                                                fontWeight={activePage === index ? 700 : 500}
                                                color={activePage === index ? theme.palette.primary.main : theme.palette.secondary.main}
                                                textAlign='center'
                                                style={{
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                {t(`${navigationLocale}.${item.label}`)}
                                            </Typography>
                                        </ListItemButton>
                                    </ListItem>
                                })
                            }

                            <Stack
                                sx={{
                                    p: 2
                                }}
                            >
                                <CustomButton 
                                    label={t(`${navigationLocale}.contact`)}
                                    onClick={contactMe}
                                />
                            </Stack>
                        </List>
                    </Drawer>
                </Stack>
            </Box>
        </>
    );
}

export default NavigationBody;